import React, {FC, memo} from 'react';
import styled from 'styled-components';
import colors from '../../../config/colors';

interface OptionType { label?: string; value?: string };

interface SelectProps {
  options: OptionType[];
  onSelectChange: (value: any) => void;
  value?: any;
  name?: string;
  defaultOption?: string;
  defaultOptionLabel?: string;
  defaultOptionDisabled?: boolean;
  defaultOptionHidden?: boolean;
  theme?: string;
}

const SelectFilter: FC<SelectProps> = (props) => {

  const {onSelectChange, options, value, name, defaultOption, defaultOptionLabel, defaultOptionDisabled, defaultOptionHidden, theme} = props;

  const setValue = (selectedOption: any) => {
    onSelectChange(selectedOption.target.value);
  }

  return (
    <SelectFilterWrapper className={`select-wrapper ${theme ? 'white' : ''}`}>
      <select name={name} onChange={(option) => setValue(option as OptionType)} value={value}>
        {defaultOptionLabel ?
          <option value={defaultOption} disabled={defaultOptionDisabled} hidden={defaultOptionHidden} >{defaultOptionLabel}</option>
        : <></>
        }
        {
          options && options.map(function(option: any, i: number){
            return <option value={option.value} key={i} >{option.label}</option>
          })
        }
      </select>
      <svg><use xlinkHref={`#select-arrow-icon`} /></svg>
    </SelectFilterWrapper>
  )
}

const SelectFilterWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  margin-bottom: 10px;

  i {
    position: absolute;
    left: 14px;
    font-size: 14px;
    color: ${colors.TEXT_GRAYLIGHT};
    z-index: 1;
    pointer-events: none;
    stroke: ${colors.GRAY_TEXT_MEDLIGHT};

    &.hasValue {
      z-index: -1;
      visibility: hidden;
    }
  }

  select {
    position: relative;
    appearance: none;
    height: 50px;
    width: 100%;
    max-width: 100%;
    background: ${colors.GRAY_EXTRA_LIGHT};
    color: ${colors.BLACK};
    border: 0;
    font-size: 14px;
    border-radius: 3px;
    padding: 0 40px 0 14px;
    transition: all 200ms ease-in-out;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    @supports (-webkit-touch-callout: none) {

      @media (max-width: 767px) {
        font-size: 16px;
      }
    }

    option[disabled],
    option:disabled {
      color: ${colors.TEXT_GRAYLIGHT};
    }

    &:focus {
      outline: none;
      box-shadow: 0px 0px 0 1px #9B9B9B29;
    }
  }

  svg {
    position: absolute;
    right: 20px;
    top: 50%;
    margin-top: -4px;
    pointer-events: none;
    width: 13px;
    height: 8px;
    stroke: ${colors.BLACK};
  }

  &.white {

    select {
      background: ${colors.WHITE};
    }
  }
`;

export default memo(SelectFilter);
